module.exports = __webpack_public_path__ + "img/wechat-phone.52ecad42.png";